import { useState } from "react";
import { StoreProductCardtype } from "../type"

const BuyProductPopUp = (product: StoreProductCardtype) => {

    const [steps, setSteps] = useState('viewInfo'); // viewInfo, payment, success , error 
    const [email, setEmail] = useState('');
    async function handlePayment() {
        // Handle payment logic here
        setSteps('payment');
        // Simulate payment processing
        setTimeout(() => {
            const isSuccess = Math.random() > 0.5; // Randomly simulate success or failure
            if (isSuccess) {
                setSteps('success');
            } else {
                setSteps('error');
            }
        }, 3000);
    }
    if (steps === 'viewInfo') {
        return (
            <div className="bg-white w-full p-6 max-h-[80vh] overflow-y-auto" style={{ scrollbarWidth: 'none' }}>
                {/* Product Info */}
                <div className="bg-gray-50 rounded-lg p-4 mb-6">
                    <div className="flex items-start gap-4">
                        <img
                            src={product.image || "https://images.pexels.com/photos/7567556/pexels-photo-7567556.jpeg"}
                            alt={product.name}
                            className="w-20 h-20 rounded-lg object-cover"
                        />
                        <div className="flex-1">
                            <div className="flex items-center justify-between gap-2 mb-1">
                                <h3 className="!text-lg font-semibold text-gray-900 !mb-0">{product.name}</h3>
                                <div className="flex flex-col sm:flex-row gap-2">
                                    {product.platform && (
                                        <div className="bg-purple-500 text-white px-2 py-1 rounded !text-xs font-semibold">
                                            🚀 {product.platform}
                                        </div>
                                    )}
                                    {product.indicator && (
                                        <div className="bg-orange-500 text-white px-2 py-1 rounded !text-xs font-semibold">
                                            {product.indicator}
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className="flex items-center gap-4 text-sm">
                                {product.star && (
                                    <div className="flex items-center gap-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-star h-4 w-4 text-yellow-400 fill-current">
                                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                                        </svg>
                                        <span className="font-medium">{product.star}</span>
                                        {product.review && (
                                            <span className="text-gray-500">({product.review} reviews)</span>
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* Price Breakdown */}
                <div className="bg-blue-50 rounded-lg p-4 mb-6">
                    <div className="flex items-center justify-between mb-3">
                        <span className="text-gray-700">Product Price:</span>
                        <div className="flex items-center gap-2">
                            {product.discount && (
                                <span className="text-gray-500 line-through">{product.price}</span>
                            )}
                            <span className="text-2xl font-bold text-gray-900">{product.finalPrice}</span>
                        </div>
                    </div>
                    {product.discount && (
                        <div className="flex items-center justify-between mb-3 text-green-600">
                            <span>Discount:</span>
                            <span className="font-semibold">-{product.discount}</span>
                        </div>
                    )}
                    <div className="border-t border-blue-200 pt-3">
                        <div className="flex items-center justify-between !text-lg font-bold">
                            <span>Total:</span>
                            <span className="text-blue-600">{product.finalPrice}</span>
                        </div>
                        <p className="text-xs text-gray-500 mt-1 !mb-0">One-time payment - Lifetime use</p>
                    </div>
                </div>
                {/* What's Included */}
                <div className="mb-6">
                    <h4 className="!text-base font-semibold text-gray-900 mb-3">What you get:</h4>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 text-sm">
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>Bot installation file (MT4, MT5 or cTrader)</span>
                        </div>
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>Detailed installation and usage guide (PDF)</span>
                        </div>
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>Instructional video (YouTube)</span>
                        </div>
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>Lifetime technical support</span>
                        </div>
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>Free updates</span>
                        </div>
                        <div className="flex items-center gap-2 text-green-600">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check h-4 w-4"><path d="M20 6 9 17l-5-5"></path></svg>
                            <span>30-day money-back guarantee</span>
                        </div>
                    </div>
                </div>
                {/* Action Buttons */}
                <div className="flex flex-col sm:flex-row gap-3">
                    <button
                        type="button"
                        className="flex-1 px-6 py-2 border border-gray-300 text-gray-700 !rounded-lg hover:bg-gray-50 transition duration-300 font-semibold"
                        onClick={() => setSteps('viewInfo')}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="flex-1 flex items-center justify-center gap-2 bg-blue-600 !text-white px-6 py-2 !rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition duration-300 font-semibold"
                        onClick={handlePayment}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-credit-card h-5 w-5">
                            <rect width="20" height="14" x="2" y="5" rx="2"></rect>
                            <line x1="2" x2="22" y1="10" y2="10"></line>
                        </svg>
                        Pay with PayPal ({product.finalPrice})
                    </button>
                </div>
                <div className="text-center mt-4">
                    <div className="flex items-center justify-center gap-2 text-xs text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-alert-circle h-4 w-4">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" x2="12" y1="8" y2="12"></line>
                            <line x1="12" x2="12.01" y1="16" y2="16"></line>
                        </svg>
                        <span>Have questions? Contact us at support@lumir.finance</span>
                    </div>
                </div>
            </div>
        )
    }
    if (steps === 'payment') {
        return (
            <div className="bg-white w-full p-6">
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl w-full text-center font-bold text-gray-900">Processing payment...</h3>
                </div>
                <div className="flex flex-col items-center gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-loader h-12 w-12 text-blue-600 animate-spin">
                        <line x1="12" x2="12" y1="2" y2="6"></line>
                        <line x1="12" x2="12" y1="18" y2="22"></line>
                        <line x1="4.93" x2="7.76" y1="4.93" y2="7.76"></line>
                        <line x1="16.24" x2="19.07" y1="16.24" y2="19.07"></line>
                        <line x1="2" x2="6" y1="12" y2="12"></line>
                        <line x1="18" x2="22" y1="12" y2="12"></line>
                        <line x1="4.93" x2="7.76" y1="19.07" y2="16.24"></line>
                        <line x1="16.24" x2="19.07" y1="7.76" y2="4.93"></line>
                    </svg>
                    <p className="text-gray-600 text-center">Please wait a moment. You will be redirected to PayPal to complete your payment.</p>
                </div>
            </div>
        )
    }
    else if (steps === 'error') {
        return (
            <div className="bg-white w-full p-6">
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl w-full text-center font-bold text-gray-900">Payment failed!</h3>
                </div>
                <div className="flex flex-col items-center gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-alert-circle h-12 w-12 text-red-600">
                        <circle cx="12" cy="12" r="10"></circle>
                        <line x1="12" x2="12" y1="8" y2="12"></line>
                        <line x1="12" x2="12.01" y1="16" y2="16"></line>
                    </svg>
                    <p className="text-gray-600 text-center">
                        Sorry, an error occurred during payment. Please try again or contact us for support.
                    </p>
                    <button
                        onClick={() => setSteps('viewInfo')}
                        className="mt-4 bg-blue-600 text-white px-4 py-2 !rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                        Try again
                    </button>
                </div>
            </div>
        )
    }
    else if (steps === 'success') {
        return (
            <div className="bg-white w-full p-6">
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl w-full text-center font-bold text-gray-900">Payment successful!</h3>
                </div>
                <div className="flex flex-col items-center gap-4">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-check-circle h-12 w-12 text-green-600">
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9 12l2 2l4 -4"></path>
                    </svg>
                    <p className="text-gray-600 text-center">
                        Thank you for purchasing {product.name}! You will receive a confirmation email and download instructions shortly.
                    </p>
                    <button
                        onClick={() => window.location.href = '/downloads'}
                        className="mt-4 bg-blue-600 text-white px-4 py-2 !rounded-lg hover:bg-blue-700 transition duration-300"
                    >
                        Go to download page
                    </button>
                </div>
            </div>
        )
    }
    return null;
}

export default BuyProductPopUp